import {
  FLOATING_TOOL_MOVED,
  CHAMBER_ROW_SET_OFFSET,
  CONTEXT_ELEMENT_DESELECT,
  STONE_BED_SWITCH_VISIBILITY,
  STONE_BED_COMPUTE,
  STONE_BED_SET_SEPARATION_DISTANCE,
  CHAMBER_SET_UPPER_CAP_ACCESORY,
  CHAMBER_SET_LOWER_CAP_ACCESORY,
  CHAMBER_SET_ACCESORY,
  SHOW_MANIFOLD_ENTRY,
  INLET_MANIFOLD_ID,
  OUTLET_MANIFOLD_ID,
  MANIFOLD_SET_ISOLATOR_STATUS,
  CHAMBERS_ISOLATOR_CLEAN,
  IS_DIRTY,
  FLOATING_TOOL_TEE_CLOSE
} from "../lib/types";
import ManifoldSelectors from "../reducers/main-manifold-reducer";
import { ManifoldUtils } from "../lib/manifolds/utils";

export const floatingToolMoved = ( x, y ) => dispatch => {
  dispatch({
    type: FLOATING_TOOL_MOVED,
    payload: { x, y }
  });
};

export const floatingToolClose = () => dispatch => {
  dispatch({
    type: CONTEXT_ELEMENT_DESELECT
  });
};

export const setStoneBedVisibility = () => dispatch => {
  dispatch({
    type: STONE_BED_SWITCH_VISIBILITY
  });
};

export const computeStoneBed = (
  chamberRows,
  chamberRowSpacingPixels,
  sepDistancePixels,
  underDrainSepDistancePixels,
  includeUnderdrain,
  manifoldSeparations,
  upperManifolds,
  lowerManifolds
) => ( dispatch, getState ) => {
  const sepDistance = getState().stonebed.sepDistance;
  const { chamberType, chamberRowSpacing, scalePixels, scaleValue } = getState().globals;
  dispatch({
    type: STONE_BED_COMPUTE,
    payload: {
      chamberRows,
      chamberRowSpacingPixels,
      sepDistancePixels,
      underDrainSepDistancePixels,
      includeUnderdrain,
      manifoldSeparations,
      upperManifolds,
      lowerManifolds,
      sepDistance,
      chamberType,
      chamberRowSpacing,
      scalePixels,
      scaleValue
    }
  });
};

export const setStoneBedSeparationDistance = (
  sepDistance,
  sepDistancePixels,
  chamberRows,
  chamberRowSpacingPixels,
  underDrainSepDistancePixels,
  includeUnderdrain,
  manifoldSeparations,
  upperManifolds,
  lowerManifolds
) => ( dispatch, getState ) => {
  const { chamberType, chamberRowSpacing, scalePixels, scaleValue } = getState().globals;
  dispatch({
    type: STONE_BED_SET_SEPARATION_DISTANCE,
    payload: {
      sepDistance,
      chamberRows,
      chamberRowSpacingPixels,
      sepDistancePixels,
      underDrainSepDistancePixels,
      includeUnderdrain,
      manifoldSeparations,
      upperManifolds,
      lowerManifolds,
      chamberType,
      chamberRowSpacing,
      scalePixels,
      scaleValue
    }
  });
};

export const setManifoldIsolatorRowStatus = ( row, col, manifoldId, isIsolator ) => dispatch => {
  dispatch({
    type: MANIFOLD_SET_ISOLATOR_STATUS,
    payload: {
      row,
      col,
      manifoldId,
      isIsolator
    }
  });
  dispatch({
    type: CHAMBERS_ISOLATOR_CLEAN,
    payload: {
      manifoldId: manifoldId,
      actualRow: row,
      actualCol: col
    }
  });
};

export const setChamberRowOffset = ( row, offSet, pixelOffSet ) => dispatch => {
  dispatch({
    type: CHAMBER_ROW_SET_OFFSET,
    payload: {
      row,
      offSet,
      pixelOffSet
    }
  });
};

export const setChamberAccesory = ( row, col, accessory ) => dispatch => {
  dispatch({
    type: CHAMBER_SET_ACCESORY,
    payload: {
      row,
      col,
      accessory
    }
  });
  dispatch({
    type: IS_DIRTY,
    payload: true
  });
};

export const setChamberUpperCapAccesory = ( row, col, accessory, preventIsolator ) => ( dispatch, getState ) => {
  const state = getState();
  const chamberRow = state.chamberbed.chamberRows[row];
  const chamber = chamberRow.chambers[col];
  let stopAddition = false;
  if (chamber.upperCapAccessory !== null) {
    if (chamber.upperCapAccessory.id === OUTLET_MANIFOLD_ID
      && accessory.id === INLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.lowerCapAccessory !== null) {
    if (chamber.lowerCapAccessory.id === OUTLET_MANIFOLD_ID
      && accessory.id === INLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.upperCapAccessory !== null) {
    if (chamber.upperCapAccessory.id === INLET_MANIFOLD_ID
      && accessory.id === OUTLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.lowerCapAccessory !== null) {
    if (chamber.lowerCapAccessory.id === INLET_MANIFOLD_ID
      && accessory.id === OUTLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }

  if (stopAddition)
    return;

  const isNewManifold = !accessory.manifoldId;
  const manifoldId = accessory.manifoldId || ManifoldUtils.generateManifoldId();
  let isModifiedManifold = false;

  if (!isNewManifold) {
    const matchingManifold = ManifoldSelectors.getManifoldByIdFromMain(manifoldId);
    isModifiedManifold = matchingManifold && matchingManifold.userModified;
  }

  dispatch({
    type: CHAMBER_SET_UPPER_CAP_ACCESORY,
    payload: {
      row,
      col,
      accessory: { ...accessory, manifoldId },
      isModifiedManifold,
      preventIsolator
    }
  });

  dispatch({
    type: SHOW_MANIFOLD_ENTRY,
    payload: {
      accessory: { ...accessory, manifoldId },
      manifoldId: manifoldId,
      checkForOverlap: !!( isNewManifold )
    }
  });
  dispatch({
    type: FLOATING_TOOL_TEE_CLOSE
  });
};

export const setChamberLowerCapAccesory = ( row, col, accessory, preventIsolator ) => ( dispatch, getState ) => {
  const state = getState();
  const chamberRow = state.chamberbed.chamberRows[row];
  const chamber = chamberRow.chambers[col];
  let stopAddition = false;

  if (chamber.lowerCapAccessory !== null) {
    if (chamber.lowerCapAccessory.id === OUTLET_MANIFOLD_ID
      && accessory.id === INLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.upperCapAccessory !== null) {
    if (chamber.upperCapAccessory.id === OUTLET_MANIFOLD_ID
      && accessory.id === INLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.upperCapAccessory !== null) {
    if (chamber.upperCapAccessory.id === INLET_MANIFOLD_ID
      && accessory.id === OUTLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }
  if (chamber.lowerCapAccessory !== null) {
    if (chamber.lowerCapAccessory.id === INLET_MANIFOLD_ID
      && accessory.id === OUTLET_MANIFOLD_ID
      && chamber.isIsolatorArray.length) {
      return stopAddition = true;
    }
  }

  if (stopAddition)
    return;

  const isNewManifold = !accessory.manifoldId;
  const manifoldId = accessory.manifoldId || ManifoldUtils.generateManifoldId();
  let isModifiedManifold = false;
  if (!isNewManifold) {
    const matchingManifold = state.lowerManifolds.manifolds.find(m => m.id === manifoldId);
    isModifiedManifold = matchingManifold && matchingManifold.userModified;
  }

  dispatch({
    type: CHAMBER_SET_LOWER_CAP_ACCESORY,
    payload: {
      row,
      col,
      accessory: { ...accessory, manifoldId },
      isModifiedManifold,
      preventIsolator
    }
  });

  dispatch({
    type: SHOW_MANIFOLD_ENTRY,
    payload: {
      accessory: { ...accessory, manifoldId },
      manifoldId: manifoldId,
      checkForOverlap: !!( isNewManifold )
    }
  });
  dispatch({
    type: FLOATING_TOOL_TEE_CLOSE
  });
};



// WEBPACK FOOTER //
// ./src/actions/floating-tool-actions.js